import React from 'react';

import { Button, Popconfirm } from 'components';
import { zPositions } from '@/constants';

import { NativeButtonProps } from 'antd/lib/button/button';
import { ContactStateType, ContactModalStateType, ContactType } from './types';
import { CONTACT_MODAL_POPCONFIRM_WIDTH } from './constants';

type ModalFooterProps = {
  contactState: ContactStateType;
  contactModalState: ContactModalStateType;
  isSaveButtonDisabled: boolean;
  onSave: (isEditMode: boolean, isClientContactEdited: boolean) => void;
  onClose: () => void;
};

const CLIENT_CONTACT_TYPES: ContactType[] = [
  'Seller',
  'Tenant',
  'Landlord/Manager',
];

const CONFIRM_MESSAGE = {
  EXISTING:
    'Saving this info will make a copy of the shared contact in your contacts module.',
  NEW: 'Saving this info will create a new contact in the listing agent’s contacts module.',
};

const ModalFooter: React.FC<ModalFooterProps> = ({
  contactState,
  contactModalState,
  isSaveButtonDisabled,
  onSave,
  onClose,
}) => {
  const { isEditMode } = contactModalState;
  const isClientContactEdited = !contactModalState.contactInputsDisabled;
  const message = contactModalState.shouldClone
    ? CONFIRM_MESSAGE.EXISTING
    : CONFIRM_MESSAGE.NEW;

  return (
    <>
      <Button onClick={onClose} data-cy="cancel-button">
        Cancel
      </Button>
      {(contactModalState.mode === 'ADD_NEW' ||
        contactModalState.shouldClone) &&
      CLIENT_CONTACT_TYPES.includes(contactState.type) ? (
        <Popconfirm
          okText="Continue"
          onConfirm={() => onSave(isEditMode, isClientContactEdited)}
          overlayStyle={{
            width: CONTACT_MODAL_POPCONFIRM_WIDTH,
            zIndex: zPositions.contactModalComponents,
          }}
          placement="top"
          title={message}
        >
          <Button
            type="primary"
            disabled={isSaveButtonDisabled}
            data-cy="save-contact-button"
          >
            Save
          </Button>
        </Popconfirm>
      ) : (
        <Button
          type="primary"
          disabled={isSaveButtonDisabled}
          onClick={() => onSave(isEditMode, isClientContactEdited)}
          data-cy="save-contact-button"
        >
          Save
        </Button>
      )}
    </>
  );
};
export default ModalFooter;
